import React, { useMemo, useState, useEffect } from "react";
import { AsideMenuList } from "./AsideMenuList";
import { useHtmlClassService } from "../../../_core/MetronicLayout";
import { useSelector } from "react-redux";

export function AsideMenu({
  disableScroll,
  setRefreshQuickCartable,
}: {
  disableScroll: any;
  setRefreshQuickCartable: any;
}) {
  const uiService = useHtmlClassService();
  const jsonFile = useSelector((state: any) => state.style);

  const layoutProps = useMemo(() => {
    return {
      layoutConfig: uiService.config,
      asideMenuAttr: uiService.getAttributes("aside_menu"),
      ulClasses: uiService.getClasses("aside_menu_nav", true),
      asideClassesFromConfig: uiService.getClasses("aside_menu", true),
    };
  }, [uiService]);

  // const loadedData = JSON.stringify(jsonFile);
  // const json = JSON.parse(loadedData);

  return (
    <>
      {/* begin::Menu Container */}
      <div
        id="kt_aside_menu"
        data-menu-vertical="1"
        className={`aside-menu my-4 ${layoutProps.asideClassesFromConfig}`}
        {...layoutProps.asideMenuAttr}
        style={
          jsonFile?.asideMenuColor
            ? { backgroundColor: jsonFile.asideMenuColor }
            : {}
        }
      >
        <AsideMenuList
          layoutProps={layoutProps}
          setRefreshQuickCartable={setRefreshQuickCartable}
        />
      </div>
      {/* end::Menu Container */}
    </>
  );
}
